import {Skeleton} from "primereact/skeleton"
import {useEffect} from "react"
import useSWR from "swr"

import {PreceptorMetricsOrientationCounts} from "../components/preceptor/PreceptorMetricsOrientationCounts"
import {PreceptorFeedbackScores} from "../components/preceptor/PreceptorFeedbackScores"
import {BarChart} from "../components/charts/BarChart"
import {ChartLegend} from "../components/charts/ChartLegend"
import {useChartColors} from "../components/charts/useChartColors"
import SubHeader from "../components/SubHeader"
import {fetcherGet} from "../utilities/general"
import {getToken} from "../utilities/useToken"

const PreceptorMetrics = () => {
    useEffect(() => {
        document.title = "My Metrics"
    }, [])
    const {user_id} = getToken()
    const {primaryColor} = useChartColors()
    const {data: preceptorSuccessRate, isLoading: successRateLoading} = useSWR(
        `/preceptors/preceptor/${user_id}/orientee-success-rate`,
        fetcherGet,
        {fallbackData: {}},
    )
    const {data: weeklyRatingsData, isLoading: weeklyRatingsLoading} = useSWR(
        `/preceptors/preceptor/${user_id}/weekly-ratings-chart`,
        fetcherGet,
        {fallbackData: {}},
    )
    const {data: feedBackScores} = useSWR(
        `/preceptors/preceptor/${user_id}/feedback-scores`,
        fetcherGet,
        {fallbackData: {}},
    )

    return (
        <div className="flex flex-col gap-4">
            <SubHeader icon="fa-hospital-user" title2="My Metrics" title1="" children={null} />
            <div className="row m-4">
                <div className="col-12 col-lg-4">
                    {successRateLoading ? (
                        <div className="card border border-gray-400">
                            <Skeleton width="100%" height="400px" />
                        </div>
                    ) : (
                        <PreceptorMetricsOrientationCounts metrics={preceptorSuccessRate || {}} />
                    )}
                </div>
                <div className="col-12 col-lg-8">
                    {weeklyRatingsLoading ? (
                        <div className="card border border-gray-400">
                            <Skeleton width="100%" height="400px" />
                        </div>
                    ) : (
                        <div className="card card-flush h-auto h-lg-100 mb-5 mb-lg-0 border border-gray-400">
                            <div className="card-header">
                                <div className="m-0 mt-3">
                                    <div className="d-flex align-items-center mb-2">
                                        <span className="fs-1 fw-bold text-gray-800 me-2 lh-1 ls-n2">
                                            {feedBackScores.overall_grade}%
                                        </span>
                                    </div>
                                    <span className="fs-6 fw-semibold text-gray-700">My Overall Preceptor Rating</span>
                                </div>
                            </div>
                            {weeklyRatingsData && weeklyRatingsData.weeks.length > 0 && (
                                <div className="card-body">
                                    <ChartLegend
                                        items={[
                                            {
                                                label: "My Average Weekly Score During Orienation Cycle",
                                                color: primaryColor,
                                            },
                                        ]}
                                    />
                                    <BarChart
                                        xData={weeklyRatingsData.weeks}
                                        ySeries={[
                                            {
                                                name: "Weekly Average Feedback Grade",
                                                values: weeklyRatingsData.preceptor_scores,
                                                width: 0.5,
                                                color: primaryColor,
                                            },
                                        ]}
                                        yMax={4}
                                        maxXTicks={20}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className="row m-4">
                <div className="col-12 ">
                    <div className="card card-flush h-auto h-lg-100 mb-5 mb-lg-0 border border-gray-400">
                        <div className="card-header py-7">
                            <div className="m-0">
                                <div className="d-flex align-items-center  ">
                                    <span className="fs-1 fw-bold text-gray-800 me-2 ">Feedback Scores</span>
                                </div>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="mb-0">
                                <div className="separator"></div>
                                <PreceptorFeedbackScores
                                    scores={feedBackScores?.questions ?? []}
                                    isLoading={feedBackScores === null}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PreceptorMetrics
